export default "__VITE_PUBLIC_ASSET__58e63a0a__"